import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import axiosAuth from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";

export default function AutoevaluacionResponder() {

  const { user } = useAuth();

  /* ==========================================
     LOADING
  ========================================== */

  const [loading, setLoading] =
    useState(false);

  const [guardando, setGuardando] =
    useState(false);

  /* ==========================================
     ENCUESTAS DISPONIBLES
  ========================================== */

  const [encuestas,
    setEncuestas] =
    useState([]);

  const [encuestaId,
    setEncuestaId] =
    useState("");

  const [encuesta,
    setEncuesta] =
    useState(null);

  /* ==========================================
     RESPUESTAS
  ========================================== */

  const [respuestas,
    setRespuestas] =
    useState({});

  /* ==========================================
     INIT
  ========================================== */

  useEffect(() => {
    cargarEncuestas();
  }, []);

  /* ==========================================
     ENCUESTAS DISPONIBLES
  ========================================== */

  const cargarEncuestas =
    async () => {

    try {

      setLoading(true);

      const { data } =
        await axiosAuth.get(
          "/autoevaluacion/disponibles"
        );

      setEncuestas(
        Array.isArray(data)
          ? data
          : []
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error cargando encuestas"
      );

    } finally {

      setLoading(false);
    }
  };

  /* ==========================================
     CARGAR ENCUESTA
  ========================================== */

  const cargarEncuesta =
    async (id) => {

    try {

      if (!id) {

        setEncuesta(null);
        return;
      }

      setLoading(true);

      const { data } =
        await axiosAuth.get(
          `/autoevaluacion/encuestas/${id}`
        );

      setEncuesta(data);

      setRespuestas({});

    } catch (error) {

      console.error(error);

      alert(
        "Error cargando encuesta"
      );

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {

    if (encuestaId) {

      cargarEncuesta(
        encuestaId
      );
    }

  }, [encuestaId]);

  /* ==========================================
     AGRUPAR PREGUNTAS
  ========================================== */

  const preguntasAgrupadas =
    useMemo(() => {

      if (
        !encuesta?.preguntas
      ) {
        return {};
      }

      return encuesta.preguntas.reduce(
        (acc, item) => {

          if (
            !acc[item.categoria]
          ) {
            acc[item.categoria] = [];
          }

          acc[item.categoria]
            .push(item);

          return acc;

        },
        {}
      );

    }, [encuesta]);
      /* ==========================================
     CAMBIAR VALOR
  ========================================== */

  const cambiarValor =
    (
      pregunta_id,
      valor
    ) => {

      setRespuestas(
        prev => ({
          ...prev,

          [pregunta_id]: {
            ...(prev[pregunta_id] || {}),
            valor
          }
        })
      );
    };

  /* ==========================================
     CAMBIAR OBSERVACION
  ========================================== */

  const cambiarObservacion =
    (
      pregunta_id,
      observacion
    ) => {

      setRespuestas(
        prev => ({
          ...prev,

          [pregunta_id]: {
            ...(prev[pregunta_id] || {}),
            observacion
          }
        })
      );
    };

  /* ==========================================
     TOTAL RESPONDIDAS
  ========================================== */

  const totalPreguntas =
    useMemo(() => {

      return encuesta?.preguntas
        ?.length || 0;

    }, [encuesta]);

  const totalRespondidas =
    useMemo(() => {

      return Object.values(
        respuestas
      ).filter(
        item =>
          item?.valor
      ).length;

    }, [respuestas]);

  const porcentaje =
    useMemo(() => {

      if (
        !totalPreguntas
      ) {
        return 0;
      }

      return Number(
        (
          (
            totalRespondidas /
            totalPreguntas
          ) * 100
        ).toFixed(0)
      );

    }, [
      totalPreguntas,
      totalRespondidas
    ]);

  /* ==========================================
     VALIDAR
  ========================================== */

  const validarEncuesta =
    () => {

      if (!encuesta) {

        alert(
          "Seleccione una encuesta"
        );

        return false;
      }

      const faltantes =
        encuesta.preguntas.filter(
          pregunta => {

            return !respuestas[
              pregunta.id
            ]?.valor;
          }
        );

      if (
        faltantes.length
      ) {

        alert(
          `Faltan ${faltantes.length} preguntas por responder`
        );

        return false;
      }

      return true;
    };

  /* ==========================================
     CONSTRUIR PAYLOAD
  ========================================== */

  const construirPayload =
    () => {

      return encuesta.preguntas.map(
        pregunta => ({

          pregunta_id:
            pregunta.id,

          valor:
            respuestas[
              pregunta.id
            ]?.valor,

          observacion:
            respuestas[
              pregunta.id
            ]?.observacion ||
            null

        })
      );
    };

      /* ==========================================
     GUARDAR ENCUESTA
  ========================================== */

  const guardarEncuesta =
    async () => {

    try {

      if (!validarEncuesta()) {
        return;
      }

      const confirmar =
        window.confirm(
          "¿Desea enviar la autoevaluación?"
        );

      if (!confirmar) {
        return;
      }

      setGuardando(true);

      const payload = {
        encuesta_id:
          encuesta.id,

        respuestas:
          construirPayload()
      };

      await axiosAuth.post(
        "/autoevaluacion/responder",
        payload
      );

      alert(
        "Encuesta enviada correctamente"
      );

      setEncuesta(null);
      setEncuestaId("");
      setRespuestas({});

      await cargarEncuestas();

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.message ||
        "Error enviando encuesta"
      );

    } finally {

      setGuardando(false);
    }
  };

  /* ==========================================
     FORMATO FECHA
  ========================================== */

  const formatFecha =
    (fecha) => {

      if (!fecha) {
        return "";
      }

      return new Date(
        fecha
      ).toLocaleDateString(
        "es-CO"
      );
    };
      return (

    <div className="director-container">

      <div className="director-card">

        <h2>
          📋 Autoevaluación Institucional
        </h2>

        <p>
          Bienvenido {user?.nombre}
        </p>

        {/* ============================
            SELECT ENCUESTA
        ============================ */}

        <div
          style={{
            marginTop: 20
          }}
        >

          <label>
            Encuesta disponible
          </label>

          <select
            value={encuestaId}
            onChange={(e) =>
              setEncuestaId(
                e.target.value
              )
            }
          >
            <option value="">
              Seleccione...
            </option>

            {encuestas.map(
              (item) => (

                <option
                  key={item.id}
                  value={item.id}
                >
                  {item.nombre}
                </option>

              )
            )}
          </select>

        </div>

        {/* ============================
            LOADING
        ============================ */}

        {loading && (
          <p>
            Cargando...
          </p>
        )}

        {/* ============================
            ENCUESTA
        ============================ */}

        {encuesta && (

          <>

            <div
              style={{
                marginTop: 20,
                padding: 15,
                border:
                  "1px solid #ddd",
                borderRadius: 10
              }}
            >

              <h3>
                {encuesta.nombre}
              </h3>

              <p>
                {
                  encuesta.descripcion
                }
              </p>

              <small>

                Vigencia:

                {" "}

                {
                  formatFecha(
                    encuesta.fecha_inicio
                  )
                }

                {" - "}

                {
                  formatFecha(
                    encuesta.fecha_fin
                  )
                }

              </small>

            </div>

            {/* ============================
                PROGRESO
            ============================ */}

            <div
              style={{
                marginTop: 20
              }}
            >

              <div
                style={{
                  width: "100%",
                  height: 20,
                  background:
                    "#eee",
                  borderRadius: 10,
                  overflow:
                    "hidden"
                }}
              >

                <div
                  style={{
                    width:
                      `${porcentaje}%`,
                    height:
                      "100%",
                    background:
                      "#4caf50"
                  }}
                />

              </div>

              <p>

                Respondidas:

                {" "}

                {
                  totalRespondidas
                }

                /

                {
                  totalPreguntas
                }

                {" ("}

                {
                  porcentaje
                }

                %)

              </p>

            </div>

            {/* ============================
                CATEGORIAS
            ============================ */}

            {Object.keys(
              preguntasAgrupadas
            ).map(
              (categoria) => (

                <div
                  key={categoria}
                  className="director-card"
                  style={{
                    marginTop: 20
                  }}
                >

                  <h3>
                    {categoria}
                  </h3>

                  {
                    preguntasAgrupadas[
                      categoria
                    ].map(
                      (pregunta) => (

                        <div
                          key={
                            pregunta.id
                          }
                          style={{
                            marginBottom:
                              25,
                            paddingBottom:
                              15,
                            borderBottom:
                              "1px solid #eee"
                          }}
                        >

                          <p
                            style={{
                              fontWeight:
                                600
                            }}
                          >
                            {
                              pregunta.pregunta
                            }
                          </p>

                          {/* ==================
                              ESCALA
                          ================== */}

                          <div
                            style={{
                              display:
                                "flex",
                              gap: 10,
                              flexWrap:
                                "wrap",
                              marginTop:
                                10
                            }}
                          >

                            {[1,2,3,4,5]
                              .map(
                                valor => (

                                <button
                                  key={
                                    valor
                                  }
                                  type="button"
                                  onClick={() =>
                                    cambiarValor(
                                      pregunta.id,
                                      valor
                                    )
                                  }
                                  style={{
                                    padding:
                                      "10px 15px",

                                    border:
                                      respuestas[
                                        pregunta.id
                                      ]?.valor === valor
                                      ? "2px solid #2196f3"
                                      : "1px solid #ccc",

                                    background:
                                      respuestas[
                                        pregunta.id
                                      ]?.valor === valor
                                      ? "#e3f2fd"
                                      : "#fff",

                                    borderRadius:
                                      8,

                                    cursor:
                                      "pointer"
                                  }}
                                >
                                  {valor}
                                </button>

                              ))
                            }

                          </div>

                          <div
                            style={{
                              marginTop: 10,
                              fontSize: 13
                            }}
                          >

                            1 = Muy Deficiente |
                            2 = Deficiente |
                            3 = Aceptable |
                            4 = Bueno |
                            5 = Excelente

                          </div>

                          {/* ==================
                              OBSERVACION
                          ================== */}

                          <textarea
                            rows={3}
                            placeholder="Observación opcional..."
                            value={
                              respuestas[
                                pregunta.id
                              ]?.observacion || ""
                            }
                            onChange={(e) =>
                              cambiarObservacion(
                                pregunta.id,
                                e.target.value
                              )
                            }
                            style={{
                              width: "100%",
                              marginTop: 10
                            }}
                          />

                        </div>

                      )
                    )
                  }

                </div>

              )
            )}

            {/* ============================
                BOTON ENVIAR
            ============================ */}

            <div
              style={{
                marginTop: 30
              }}
            >

              <button
                type="button"
                onClick={
                  guardarEncuesta
                }
                disabled={
                  guardando
                }
              >

                {
                  guardando
                    ? "Guardando..."
                    : "Enviar Autoevaluación"
                }

              </button>

            </div>

          </>

        )}

      </div>

    </div>

  );
}